interface FetchParams {
  notificationGroup: string;
  page: string;
  perPage: string;
}

interface IdParams {
  id: string;
}

interface UnfollowParams {
  followerId: string;
  postId: string;
}

interface FollowParams {
  postId: string;
}

interface FetchNotificationCountParams {
  communityId: string;
}

export const notificationsApi = {
  fetch: (params: FetchParams) =>
    `/internal_api/notifications?page=${params.page}&per_page=${params.perPage}&notification_group=${params.notificationGroup}`,
  markAsRead: (params: IdParams) =>
    `/internal_api/notifications/${params.id}/mark_as_read`,
  markAllAsRead: () => "/internal_api/notifications/mark_all_as_read",
  archive: (params: IdParams) =>
    `/internal_api/notifications/${params.id}/archive`,
  unfollow: (params: UnfollowParams) =>
    `/internal_api/posts/${params.postId}/post_followers/${params.followerId}`,
  follow: (params: FollowParams) =>
    `/internal_api/posts/${params.postId}/post_followers`,
  resetNotificationCount: () =>
    `/internal_api/notifications/reset_new_notifications_count`,
  fetchNotificationCount: (params: FetchNotificationCountParams) =>
    `/internal_api/notifications/new_notifications_count?community_id=${params.communityId}`,
};
